import OneSignal from 'react-onesignal';

export default async function runOneSignal() {
  await OneSignal.init({ appId: '2213ffa9-b7cc-4983-a376-f064dda6eba0', allowLocalhostAsSecureOrigin: true});
  OneSignal.showSlidedownPrompt();
}